import {Box} from '@primer/react'

import {AddSubIssueButtonGroup} from './AddSubIssueButtonGroup'
import {Suspense, useState} from 'react'
import {SubIssuesListLoadingSkeleton} from './SubIssuesListLoadingSkeleton'
import {SubIssuesListView} from './SubIssuesListView'
import {graphql} from 'relay-runtime'
import {useFragment} from 'react-relay'
import type {SubIssuesList$key} from './__generated__/SubIssuesList.graphql'

export function SubIssuesList({issueKey}: {issueKey: SubIssuesList$key}) {
  const [shouldRefetch, setShouldRefetch] = useState(false)

  const subIssuesListData = useFragment(
    graphql`
      fragment SubIssuesList on Issue {
        id
        ...AddSubIssueButtonGroup
      }
    `,
    issueKey,
  )

  return (
    <Box
      sx={{
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'border.default',
        borderRadius: 2,
        gap: 4,
      }}
    >
      <Suspense fallback={<SubIssuesListLoadingSkeleton />}>
        <SubIssuesListView
          issueID={subIssuesListData.id}
          shouldRefetch={shouldRefetch}
          onRefetch={() => {
            setShouldRefetch(false)
          }}
        />
      </Suspense>
      <Box sx={{p: 2}}>
        <AddSubIssueButtonGroup issue={subIssuesListData} onCreateSubIssueSuccess={() => setShouldRefetch(true)} />
      </Box>
    </Box>
  )
}

try{ SubIssuesList.displayName ||= 'SubIssuesList' } catch {}